module.exports = __webpack_public_path__ + "static/media/barcode.0aa7134a.png";